import { useState } from 'react';
import { useTracking } from 'react-tracking';
import { Button } from '@simplywallst/ui-core/next';
import loadable from '@loadable/component';
import { useTranslation } from '@/hooks/useTranslation';

const GuestRegistrationModal = loadable(
  () => import(/* webpackPrefetch: true */ '@components/GuestRegistrationModal')
);

export const DesktopTopbarLoggedOut = () => {
  const { trackEvent } = useTracking();
  const t = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="flex items-center justify-center overflow-hidden [&>button]:truncate">
      <Button
        data-cy-id="login-signup"
        variant="primary"
        size="large"
        onClick={() => {
          setOpen(true);
          trackEvent({
            type: 'track',
            action: 'click',
            modifier: 'desktopTopBarLoggedOut',
            subject: 'guestRegistrationModal',
          });
        }}
      >
        {t('app.topbar.nav.account.loginOrSignup')}
      </Button>
      {open && (
        <GuestRegistrationModal
          canClose={true}
          onClose={() => {
            trackEvent({
              action: 'click',
              modifier: 'log_in_sign_up',
            });
            setOpen(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              type: 'track',
              subject: 'desktopTopBarLoggedOut',
              modifier: 'registration',
              action: 'success',
            });
          }}
        />
      )}
    </div>
  );
};
